module.exports = __webpack_public_path__ + "img/portrait.48254492.jpg";